module.exports = __webpack_public_path__ + "/assets/img/icon_refresh56911005.svg";